import { useId, useEffect } from "react";
import './input-base.css'
import './input-select.css'

export default function SelectionInput (props: {
	label: string,
	value: string | number,
  infoButton?: ReactNode,
  options: Array<{label: string, value: string | number}>,
  onChange: (value: string) => void
  onBlur?: () => void,
}){
  const id = useId();

  // useEffect(()=>{
  //   if(props.options && props.options.length > 0){
  //     props.onChange(props.options[0].value.toString());
  //   }
  // },[]);

  return <div className={"select-input input"}>
        <label className={"select-input__label input__label"} htmlFor={id}>{props.infoButton}{props.label}</label>
        <select className={"select-input__input input__input"} tabIndex={0} id={id} value={props.value} onBlur={()=>{
          if(props.onBlur == undefined ){return;}
          props.onBlur();
        }} onChange={(e)=>{
          props.onChange(e.target.value);
          }}>
          {props.options.map((option)=><option key={option.label} value={option.value}>{option.label}</option>)}
        </select>
    </div>
}
